/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tunneledMcpCreateServer } from "../funcs/tunneledMcpCreateServer.js";
import { tunneledMcpDeleteServer } from "../funcs/tunneledMcpDeleteServer.js";
import { tunneledMcpGetServer } from "../funcs/tunneledMcpGetServer.js";
import { tunneledMcpGetServerMetrics } from "../funcs/tunneledMcpGetServerMetrics.js";
import { tunneledMcpListServerConnections } from "../funcs/tunneledMcpListServerConnections.js";
import { tunneledMcpListServers } from "../funcs/tunneledMcpListServers.js";
import { tunneledMcpRotateServerKey } from "../funcs/tunneledMcpRotateServerKey.js";
import { tunneledMcpUpdateServer } from "../funcs/tunneledMcpUpdateServer.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateTunneledMcpServerResult } from "../models/components/createtunneledmcpserverresult.js";
import { ListTunneledMcpServersResult } from "../models/components/listtunneledmcpserversresult.js";
import { RotateTunneledMcpServerKeyResult } from "../models/components/rotatetunneledmcpserverkeyresult.js";
import { TunneledMcpServer } from "../models/components/tunneledmcpserver.js";
import { TunneledMcpServerConnections } from "../models/components/tunneledmcpserverconnections.js";
import { TunnelMetrics } from "../models/components/tunnelmetrics.js";
import {
  CreateTunneledMcpServerRequest,
  CreateTunneledMcpServerSecurity,
} from "../models/operations/createtunneledmcpserver.js";
import {
  DeleteTunneledMcpServerRequest,
  DeleteTunneledMcpServerSecurity,
} from "../models/operations/deletetunneledmcpserver.js";
import {
  GetTunneledMcpServerRequest,
  GetTunneledMcpServerSecurity,
} from "../models/operations/gettunneledmcpserver.js";
import {
  GetTunneledMcpServerMetricsRequest,
  GetTunneledMcpServerMetricsSecurity,
} from "../models/operations/gettunneledmcpservermetrics.js";
import {
  ListTunneledMcpServerConnectionsRequest,
  ListTunneledMcpServerConnectionsSecurity,
} from "../models/operations/listtunneledmcpserverconnections.js";
import {
  ListTunneledMcpServersRequest,
  ListTunneledMcpServersSecurity,
} from "../models/operations/listtunneledmcpservers.js";
import {
  RotateTunneledMcpServerKeyRequest,
  RotateTunneledMcpServerKeySecurity,
} from "../models/operations/rotatetunneledmcpserverkey.js";
import {
  UpdateTunneledMcpServerRequest,
  UpdateTunneledMcpServerSecurity,
} from "../models/operations/updatetunneledmcpserver.js";
import { unwrapAsync } from "../types/fp.js";

export class TunneledMcp extends ClientSDK {
  /**
   * createServer tunneledMcp
   *
   * @remarks
   * Create a new tunneled MCP server source. Returns the tunnel key once.
   */
  async createServer(
    request: CreateTunneledMcpServerRequest,
    security?: CreateTunneledMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateTunneledMcpServerResult> {
    return unwrapAsync(tunneledMcpCreateServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteServer tunneledMcp
   *
   * @remarks
   * Delete a tunneled MCP server source
   */
  async deleteServer(
    request: DeleteTunneledMcpServerRequest,
    security?: DeleteTunneledMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(tunneledMcpDeleteServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServer tunneledMcp
   *
   * @remarks
   * Get a tunneled MCP server by ID
   */
  async getServer(
    request: GetTunneledMcpServerRequest,
    security?: GetTunneledMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TunneledMcpServer> {
    return unwrapAsync(tunneledMcpGetServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServerMetrics tunneledMcp
   *
   * @remarks
   * Read seven-day payload-free tunnel activity aggregates
   */
  async getServerMetrics(
    request: GetTunneledMcpServerMetricsRequest,
    security?: GetTunneledMcpServerMetricsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TunnelMetrics> {
    return unwrapAsync(tunneledMcpGetServerMetrics(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listServerConnections tunneledMcp
   *
   * @remarks
   * List live tunnel connections for a tunneled MCP server
   */
  async listServerConnections(
    request: ListTunneledMcpServerConnectionsRequest,
    security?: ListTunneledMcpServerConnectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TunneledMcpServerConnections> {
    return unwrapAsync(tunneledMcpListServerConnections(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listServers tunneledMcp
   *
   * @remarks
   * List all tunneled MCP server sources for a project
   */
  async listServers(
    request?: ListTunneledMcpServersRequest | undefined,
    security?: ListTunneledMcpServersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListTunneledMcpServersResult> {
    return unwrapAsync(tunneledMcpListServers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateServerKey tunneledMcp
   *
   * @remarks
   * Rotate a tunneled MCP server source key. Returns the new tunnel key once.
   */
  async rotateServerKey(
    request: RotateTunneledMcpServerKeyRequest,
    security?: RotateTunneledMcpServerKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<RotateTunneledMcpServerKeyResult> {
    return unwrapAsync(tunneledMcpRotateServerKey(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateServer tunneledMcp
   *
   * @remarks
   * Update a tunneled MCP server source
   */
  async updateServer(
    request: UpdateTunneledMcpServerRequest,
    security?: UpdateTunneledMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TunneledMcpServer> {
    return unwrapAsync(tunneledMcpUpdateServer(
      this,
      request,
      security,
      options,
    ));
  }
}
